import { useState } from 'react'
import Date from '../../../../Core/Fields/Floating/Date';
import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import Textarea from '../../../../Core/Fields/Floating/Textarea';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import { FiChevronDown } from 'react-icons/fi'
import ActivityCard from '../../../../Core/Activity/ActivityCard';
const Tab5 = ({
    taxId, setTaxId,
    settaxCategory, taxcategory, taxcatlist,
    taxwithholdlist, setTaxwithholds, taxwithholds,
    price, setPrice, pricelist,
    gst, setGst, setPan, pan,
    GstCategorylist, setGstCategory, gstCategory,customerName
}) => {

    const [isGroup, setIsGroup] = useState(0)


    return (
          <div>
      <div className="px-2 py-3" style={{ background: 'white' }}>
        <div style={{ display: 'flex' }} >
          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
                 <div style={{ flex: 1 }}>
                     <Input
                                id="CustomerName"
                                label="Tax ID"
                                style={{ height: "30px" }}
                                readOnly
                                value={taxId}
                                onChange={(e) => setTaxId(e.target.value)}
                            />

                </div>
                <div style={{ flex: 1 }}>
                     <Input
                                label="Tax Category"
                                value={taxcategory}
                                readOnly
                                style={{ height: "30px" }}
                            />

                </div>
                <div style={{ flex: 1 }}>
                     <Input
                                label="Tax Withholding Category"
                                value={taxwithholds}
                                readOnly
                                style={{ height: "30px" }}
                            />
                </div>
              </div>


            </div>
          </div>

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Tax Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>

               <div style={{ flex: 1 }}>
                    <Input
                                id="GSTIN / UIN"
                                label="GSTIN / UIN"
                                style={{ height: "30px" }}
                                readOnly
                                value={gst}
                                onChange={(e) => setGst(e.target.value)}
                            />
                </div>
                <div style={{ flex: 1 }}>
                 <Input
                                id="PAN"
                                label="PAN"
                                style={{ height: "30px" }}
                                value={pan}
                                readOnly
                                onChange={(e) => setPan(e.target.value)}
                            />


                </div>
                <div style={{ flex: 1 }}>
                   <Input
                                label="GST Category"
                                value={gstCategory}
                                readOnly
                                style={{ height: "30px" }}
                            />
                </div>

              </div>




            </div>
          </div>
        </div>
         <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
             <ActivityCard doctype="Customer" docname={customerName} />
            </div>
          </div>
        </div>
      </div>

    </div>

    )
}

export default Tab5